import { type ManualSyncRequest, manualSyncResponseSchema } from "@adpilot/shared";
import { api } from "./api";

export async function startManualSync(input: ManualSyncRequest) {
  const response = await api
    .post("sync/manual", { json: input })
    .json<{ success: true; data: unknown }>();
  return manualSyncResponseSchema.parse(response.data);
}
